function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7492 3L9.9292 2.295C9.81025 2.26519 9.68808 2.25007 9.56545 2.25H6.55195C6.27333 2.25001 6.00022 2.32762 5.76323 2.47413C5.52624 2.62064 5.33474 2.83026 5.2102 3.0795L2.5852 8.3295C2.47093 8.55819 2.417 8.81229 2.42853 9.06768C2.44006 9.32307 2.51668 9.57127 2.65111 9.78873C2.78553 10.0062 2.97331 10.1857 3.1966 10.3102C3.41989 10.4346 3.6713 10.5 3.92695 10.5H7.49995L7.4992 14.25C7.4992 14.6478 7.65724 15.0294 7.93854 15.3107C8.21985 15.592 8.60138 15.75 8.9992 15.75H9.0712C9.4462 15.75 9.74995 15.4463 9.74995 15.072C9.74995 14.5358 9.9082 14.0123 10.206 13.566L12.75 9.75L12.7492 3ZM12.7492 3H14.25C14.6478 3 15.0293 3.15804 15.3106 3.43934C15.5919 3.72064 15.75 4.10218 15.75 4.5V9C15.75 9.39782 15.5919 9.77936 15.3106 10.0607C15.0293 10.342 14.6478 10.5 14.25 10.5H12.375",
  stroke: "#1F2145",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDownvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/downvote.b3330cf4.svg";
export { ForwardRef as ReactComponent };